import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faClock, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';

export interface StarterPrompt {
    text: string;
    icon: IconDefinition;
    iconColor: string;
    iconBg: string;
}

export const STARTER_PROMPTS: StarterPrompt[] = [
    {
        text: 'Where should I focus my attention to reduce risk today?',
        icon: faTriangleExclamation,
        iconColor: 'var(--eidDangerRed)',
        iconBg: 'var(--eidDangerRed-10)',
    },
    {
        text: 'Which entities have stopped responding to outreach?',
        icon: faClock,
        iconColor: 'var(--eidImpactOrange)',
        iconBg: 'var(--eidImpactOrange-10)',
    },
];
